export const buildReorderItems = <T extends { id: string }>(
  items: T[],
  id: string,
  direction: 'up' | 'down',
) => {
  const index = items.findIndex((item) => item.id === id);
  if (index < 0) return null;

  const targetIndex = direction === 'up' ? index - 1 : index + 1;
  if (targetIndex < 0 || targetIndex >= items.length) return null;

  const next = [...items];
  [next[index], next[targetIndex]] = [next[targetIndex], next[index]];

  return next.map((item, sortOrder) => ({ id: item.id, sortOrder }));
};

export const getAccessLabel = (isForAllCompanies: boolean, companyIds: string[]) => {
  if (isForAllCompanies) return 'Все компании';
  return `Выбранные (${companyIds.length})`;
};

export const getCompanyNames = (
  companyIds: string[],
  companies: Array<{ id: string; name: string }>,
) => {
  if (!companyIds.length) return '';

  return companyIds
    .map((companyId) => companies.find((company) => company.id === companyId)?.name ?? companyId)
    .join(', ');
};
